export default __webpack_public_path__ + "fonts/BankOwned-White.svg";